module.exports = __webpack_public_path__ + "img/bx-grade-choosing-report.c289117a.svg";